<article class="live-table-layout">
  <ftr-animated-remote
    [remote]="entities"
    [loadingTemplate]="loading"
    [failureTemplate]="failure"
    [successTemplate]="success"
    [emptyTemplate]="empty"
  >
    <ng-template #loading>
      <ftr-line-loader [isLoading]="true" [message]="'Loading ' + plural" [fullPage]="true"></ftr-line-loader>
    </ng-template>

    <ng-template #failure>
      <section class="card-list card-list__error">
        <ng-container *ngTemplateOutlet="layoutHeaderTemplate"></ng-container>
        <div class="card media">
          <ftr-error-retry [text]="'Failed to retrieve ' + plural" (retry)="refresh.next()"></ftr-error-retry>
        </div>
      </section>
    </ng-template>
    <ng-template #empty>
      <section class="card-list card-list__empty">
        <ng-container *ngTemplateOutlet="layoutHeaderTemplate"></ng-container>
        <div class="card media">
          <p>You have no {{ plural }} yet.</p>
        </div>
      </section>
    </ng-template>
    <ng-template #success let-items>
      <section>
        <ng-container *ngTemplateOutlet="layoutHeaderTemplate; context: { $implicit: items }"></ng-container>
        <ftr-table
          [items]="items"
          [columns]="columns"
          [trackBy]="trackBy"
          [verticalBreakpoint]="verticalBreakpoint"
        ></ftr-table>
      </section>
    </ng-template>
  </ftr-animated-remote>
</article>

<ng-template #layoutHeaderTemplate let-items>
  <ftr-live-table-layout-header
    [title]="title"
    [plural]="plural"
    [singular]="singular"
    [summary]="summary"
    [count]="items?.length || 0"
    [updateIntervalMs]="updateIntervalMs"
    [isSuccess]="isSuccess"
    [pauseUpdatesOnScroll]="pauseUpdatesOnScroll"
    [filter]="filter"
    (refresh)="refresh.next()"
  ></ftr-live-table-layout-header>
</ng-template>
